const CONFLUENCE_BASE = 'https://gumgum.jira.com/wiki/spaces/GCDC/pages';

const contentUS = [
	{
	  "name": "IN-SCREEN",
	  "key": 0,
	  "units": [
		{
		  "label": "In-Screen",
		  "path": "/In-Screen",
		  "url": `${CONFLUENCE_BASE}/4216324125`,
		  "type": "IN-SCREEN",
		  "key": 0,
		  "id": 0,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "In-Screen Frame",
		  "path": "/In-Screen-Frame",
		  "url": `${CONFLUENCE_BASE}/4216356890`,
		  "type": "IN-SCREEN",
		  "key": 1,
		  "id": 1,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "In-Screen Expandable",
		  "path": "/In-Screen-Expandable",
		  "url": `${CONFLUENCE_BASE}/4228743318`,
		  "type": "IN-SCREEN",
		  "key": 2,
		  "id": 2,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "In-Screen Expandable Video",
		  "path": "/In-Screen-Expandable-Video",
		  "url": `${CONFLUENCE_BASE}/4228743271`,
		  "type": "IN-SCREEN",
		  "key": 3,
		  "id": 3,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "In-Screen Expandable Corner",
		  "path": "/In-Screen-Expandable-Corner",
		  "url": `${CONFLUENCE_BASE}/4216356913`,
		  "type": "IN-SCREEN",
		  "key": 4,
		  "id": 8,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "Velocity",
		  "path": "/Velocity",
		  "url": `${CONFLUENCE_BASE}/4216553473`,
		  "type": "IN-SCREEN",
		  "key": 5,
		  "id": 42,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "IN-IMAGE",
	  "key": 1,
	  "units": [
		{
		  "label": "In-Image Expandable",
		  "path": "/In-Image-Expandable",
		  "url": `${CONFLUENCE_BASE}/4228743318`,
		  "type": "IN-IMAGE",
		  "key": 1,
		  "id": 5,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "6-Sec Video Canvas",
		  "path": "/6-Sec-Video-Canvas",
		  "url": `${CONFLUENCE_BASE}/4242112523`,
		  "type": "IN-IMAGE",
		  "key": 3,
		  "id": 7,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "SKINS",
	  "key": 2,
	  "units": [
		{
		  "label": "Desktop Skin - Complex",
		  "path": "/Desktop-Skin-Complex",
		  "url": "",
		  "type": "SKINS",
		  "key": 0,
		  "id": 26,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Desktop Skin - Standard",
		  "path": "/Desktop-Skin-Standard",
		  "url": "",
		  "type": "SKINS",
		  "key": 1,
		  "id": 29,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Desktop Skin - Express",
		  "path": "/Desktop-Skin-Express",
		  "url": "",
		  "type": "SKINS",
		  "key": 2,
		  "id": 30,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Desktop Skin - IAB",
		  "path": "/Desktop-Skin-IAB",
		  "url": "",
		  "type": "SKINS",
		  "key": 3,
		  "id": 31,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Mobile Skin - Complex",
		  "path": "/Mobile-Skin-Complex",
		  "url": "",
		  "type": "SKINS",
		  "key": 4,
		  "id": 27,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Mobile Skin - Standard",
		  "path": "/Mobile-Skin-Standard",
		  "url": "",
		  "type": "SKINS",
		  "key": 5,
		  "id": 32,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Mobile Skin - Express",
		  "path": "/Mobile-Skin-Express",
		  "url": "",
		  "type": "SKINS",
		  "key": 6,
		  "id": 33,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Mobile Skin - IAB",
		  "path": "/Mobile-Skin-IAB",
		  "url": "",
		  "type": "SKINS",
		  "key": 7,
		  "id": 23,
		  "hidden": true,
		  "path_alias": ""
		},
		{
		  "label": "Mobile Skin",
		  "path": "/Mobile-Skin",
		  "url": `${CONFLUENCE_BASE}/4228612258`,
		  "type": "SKINS",
		  "key": 8,
		  "id": 40,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "Desktop Skin",
		  "path": "/Desktop-Skin",
		  "url": `${CONFLUENCE_BASE}/4229070927`,
		  "type": "SKINS",
		  "key": 9,
		  "id": 41,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "IN-ARTICLE",
	  "key": 3,
	  "units": [
		{
		  "label": "Mobile Scroller",
		  "path": "/Mobile-Scroller",
		  "url": `${CONFLUENCE_BASE}/4228710463`,
		  "type": "IN-ARTICLE",
		  "key": 0,
		  "id": 28,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "Hang Time Display",
		  "path": "/Hang-Time-Display",
		  "url": `${CONFLUENCE_BASE}/4227104800`,
		  "type": "IN-ARTICLE",
		  "key": 1,
		  "id": 35,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "Hang Time Video",
		  "path": "/Hang-Time-Video",
		  "url": `${CONFLUENCE_BASE}/4224745526`,
		  "type": "IN-ARTICLE",
		  "key": 2,
		  "id": 36,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "Interactive",
	  "key": 4,
	  "units": [
		{
		  "label": "In-Game",
		  "path": "/In-Game",
		  "url": `${CONFLUENCE_BASE}/4228743302`,
		  "type": "Interactive",
		  "key": 0,
		  "id": 34,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "IN-SLOT",
	  "key": 5,
	  "units": [
		{
		  "label": "Contextual OLV",
		  "path": "/Contextual-OLV",
		  "url": `${CONFLUENCE_BASE}/4242407429`,
		  "type": "IN-SLOT",
		  "key": 0,
		  "id": 37,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "CTV",
	  "key": 6,
	  "units": [
		{
		  "label": "CTV Standard Video",
		  "path": "/CTV-Standard-Video",
		  "url": `${CONFLUENCE_BASE}/4503666689`,
		  "type": "CTV",
		  "key": 0,
		  "id": 43,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "IN-VIDEO",
	  "key": 7,
	  "units": [
		{
		  "label": "In-Video Spark",
		  "path": "/In-Video-Spark",
		  "url": `${CONFLUENCE_BASE}/4224843868`,
		  "type": "IN-VIDEO",
		  "key": 0,
		  "id": 24,
		  "hidden": false,
		  "path_alias": "/In-Video-Corner"
		},
		{
		  "label": "In-Video Squeezeback",
		  "path": "/In-Video-Squeezeback",
		  "url": `${CONFLUENCE_BASE}/4224876597`,
		  "type": "IN-VIDEO",
		  "key": 1,
		  "id": 38,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "In-Video Spotlight",
		  "path": "/In-Video-Spotlight",
		  "url": `${CONFLUENCE_BASE}/4224680041`,
		  "type": "IN-VIDEO",
		  "key": 2,
		  "id": 39,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "STANDARD",
	  "key": 8,
	  "units": [
		{
		  "label": "728x90",
		  "path": "/Standard-728x90",
		  "url": `${CONFLUENCE_BASE}/4224778279`,
		  "type": "STANDARD",
		  "key": 0,
		  "id": 14,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "320x50",
		  "path": "/Standard-320x50",
		  "url": `${CONFLUENCE_BASE}/4224843884`,
		  "type": "STANDARD",
		  "key": 1,
		  "id": 15,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	},
	{
	  "name": "DISPLAY",
	  "key": 9,
	  "units": [
		{
		  "label": "320x50",
		  "path": "/Display-320x50",
		  "url": `${CONFLUENCE_BASE}/4224680048`,
		  "type": "DISPLAY",
		  "key": 0,
		  "id": 16,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "728x90",
		  "path": "/Display-728x90",
		  "url": `${CONFLUENCE_BASE}/4205773018`,
		  "type": "DISPLAY",
		  "key": 1,
		  "id": 17,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "300x250",
		  "path": "/Display-300x250",
		  "url": `${CONFLUENCE_BASE}/4225138751`,
		  "type": "DISPLAY",
		  "key": 2,
		  "id": 18,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "160x600",
		  "path": "/Display-160x600",
		  "url": `${CONFLUENCE_BASE}/4224680058`,
		  "type": "DISPLAY",
		  "key": 3,
		  "id": 19,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "468x60",
		  "path": "/Display-468x60",
		  "url": `${CONFLUENCE_BASE}/4225106006`,
		  "type": "DISPLAY",
		  "key": 4,
		  "id": 20,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "640x480",
		  "path": "/Display-640x480",
		  "url": `${CONFLUENCE_BASE}/4224680073`,
		  "type": "DISPLAY",
		  "key": 5,
		  "id": 21,
		  "hidden": false,
		  "path_alias": ""
		},
		{
		  "label": "970x90",
		  "path": "/Display-970x90",
		  "url": `${CONFLUENCE_BASE}/4225138759`,
		  "type": "DISPLAY",
		  "key": 6,
		  "id": 22,
		  "hidden": false,
		  "path_alias": ""
		}
	  ]
	}
  ];

const contentUK = [
	{
		name: 'Proprietary',
		key: 0,
		units: [
			{
				label:'In-Screen',
				path: '/In-Screen',
				url: 'https://embed.getguru.com/card/irA5M6oT/InScreen-UK-Specs',
				type: 'Proprietary',
				key: 0,
				id: 0
			},
			{
				label:'In-Screen Frame',
				path: '/In-Screen-Frame',
				url: 'https://embed.getguru.com/card/cMkX6K9i/InScreen-Frame-UK-Specs',
				type: 'Proprietary',
				key: 1,
				id: 1
			},
			{
				label:'In-Screen Expandable',
				path: '/In-Screen-Expandable',
				url: 'https://embed.getguru.com/card/cnAoA79i/InScreen-Expandable-UK-Specs',
				type: 'Proprietary',
				key: 2,
				id: 2
			},
			{
				label:'In-Screen Expandable Video',
				path: '/In-Screen-Expandable-Video',
				url: 'https://embed.getguru.com/card/cgA54e7i/InScreen-Expandable-Video-UK-Specs',
				type: 'Proprietary',
				key: 3,
				id: 3
			},
			{
				label:'In-Image',
				path: '/In-Image',
				url: 'https://embed.getguru.com/card/TKkr6pMc/InImage-UK-Specs',
				type: 'Proprietary',
				key: 4,
				id: 4
			},
			{
				label:'In-Image Expandable',
				path: '/In-Image-Expandable',
				url: 'https://embed.getguru.com/card/T4A5Mo5c/InImage-Expandable-UK-Specs',
				key: 5,
				id: 5
			},
			{
				label:'Canvas',
				path: '/Canvas',
				url: 'https://embed.getguru.com/card/TEg86pqc/Canvas-UK-Specs',
				type: 'Proprietary',
				key: 6,
				id: 6
			},
			{
				label:'6-Sec Video Canvas',
				path: '/6-Sec-Video-Canvas',
				url: 'https://embed.getguru.com/card/cRAajR7i/6Sec-Video-Canvas-UK-Specs',
				type: 'Proprietary',
				key: 7,
				id: 7
			},
			{
				label:'In-Screen Expandable Corner',
				path: '/In-Screen-Expandable-Corner',
				url: 'https://embed.getguru.com/card/iLg96E4T/InScreen-Expandable-Corner-UK-Specs',
				type: 'Proprietary',
				key: 8,
				id: 8
			},
			{
				label:'In-Article Shoppable',
				path: '/In-Article-Shoppable',
				url: 'https://embed.getguru.com/card/c5AqnaGi/InArticle-Shoppable-UK-Specs',
				type: 'Proprietary',
				key: 9,
				id: 9
			},
			{
				label:'In-Article Video',
				path: '/In-Article-Video',
				url: 'https://embed.getguru.com/card/cRAajKbi/InArticle-Video-UK-Specs',
				type: 'Proprietary',
				key: 10,
				id: 25
			},
			{
				label:'Desktop Skin',
				path: '/Desktop-Skin',
				url: 'https://embed.getguru.com/card/ieAnz4dT/Desktop-Skins-UK-Specs',
				type: 'Proprietary',
				key: 11,
				id: 26
			},
			{
				label:'Mobile Skin',
				path: '/Mobile-Skin',
				url: 'https://embed.getguru.com/card/ceAnz4Mi/Mobile-Skin-UK-Specs',
				type: 'Proprietary',
				key: 12,
				id: 27
			},
			{
				label:'Mobile Scroller',
				path: '/Mobile-Scroller',
				url: 'https://embed.getguru.com/card/iBgApLrT/Mobile-Scroller-UK-Specs',
				type: 'Proprietary',
				key: 13,
				id: 28
			}
		]
	},
	{
		name: 'CTV/OTT',
		key: 1,
		units: [
			{
				label:'In-Video Snipe',
				path: '/In-Video-Snipe',
				url: 'https://embed.getguru.com/card/TrA5M6ac/InVideo-Snipe-UK-Specs',
				type: 'Proprietary',
				key: 0,
				id: 23
			},
			{
				label:'In-Video Corner',
				path: '/In-Video-Corner',
				url: 'https://embed.getguru.com/card/cnAaR94i/InVideo-Corner-UK-Specs',
				type: 'Proprietary',
				key: 1,
				id: 24
			}
		]
	},
	{
		name: 'Social',
		key: 2,
		units: [
			{
				label:'Native',
				path: '/Native',
				url: 'https://embed.getguru.com/card/T6A5MzKc/Native-UK-Specs',
				type: 'Social',
				key: 0,
				id: 10
			},
			{
				label:'Story',
				path: '/Story',
				url: 'https://embed.getguru.com/card/TeAnzp6c/Story-UK-Specs',
				type: 'Social',
				key: 1,
				id: 11
			}
		]
	},
	{
		name: 'Interactive',
		key: 3,
		units: [
			{
				label:'Carousel',
				path: '/Carousel',
				url: 'https://embed.getguru.com/card/crA5MR7i/Interactive-Carousel-UK-Specs',
				type: 'Interactive',
				key: 0,
				id: 12
			},
			{
				label:'Scroll',
				path: '/Scroll',
				url: 'https://embed.getguru.com/card/cEg86EXi/Interactive-Scroll-UK-Specs',
				type: 'Interactive',
				key: 1,
				id: 13
			}
		]
	},
	{
		name: 'Standard',
		key: 4,
		units: [
			{
				label:'728x90',
				path: '/Standard-728x90',
				url: 'https://embed.getguru.com/card/TEg8kR8c/Standard-728x90-UK-Specs',
				type: 'Standard',
				key: 0,
				id: 14
			},
			{
				label:'320x50',
				path: '/Standard-320x50',
				url: 'https://embed.getguru.com/card/i5AqGzET/Standard-320x50-UK-Specs',
				type: 'Standard',
				key: 1,
				id: 15
			}
		]
	},
	{
		name: 'Display',
		key: 5,
		units: [
			{
				label:'320x50',
				path: '/Display-320x50',
				url: 'https://embed.getguru.com/card/T5AqGz8c/InSlot-320x50-UK-Specs',
				type: 'Display',
				key: 0,
				id: 16
			},
			{
				label:'728x90',
				path: '/Display-728x90',
				url: 'https://embed.getguru.com/card/iqA5GkjT/InSlot-728x90-UK-Specs',
				type: 'Display',
				key: 1,
				id: 17
			},
			{
				label:'300x250',
				path: '/Display-300x250',
				url: 'https://embed.getguru.com/card/iEg86oRT/InSlot-300x250-UK-Specs',
				type: 'Display',
				key: 2,
				id: 18
			},
			{
				label:'160x600',
				path: '/Display-160x600',
				url: 'https://embed.getguru.com/card/iMkX65zT/InSlot-160x600-UK-Specs',
				type: 'Display',
				key: 3,
				id: 19
			},
			{
				label:'468x60',
				path: '/Display-468x60',
				url: 'https://embed.getguru.com/card/ibAazjgT/InSlot-468x60-UK-Specs',
				type: 'Display',
				key: 4,
				id: 20
			},
			{
				label:'640x480',
				path: '/Display-640x480',
				url: 'https://embed.getguru.com/card/czA5Mpdi/InSlot-640x480-UK-Specs',
				type: 'Display',
				key: 5,
				id: 21
			},
			{
				label:'970x90',
				path: '/Display-970x90',
				url: 'https://embed.getguru.com/card/cBgApGgi/InSlot-970x90-UK-Specs',
				type: 'Display',
				key: 6,
				id: 22
			}
		]
	}
]

const navContent = process.env.REACT_APP_GEO === 'UK' ? contentUK : contentUS;

export {navContent};
